import * as React from 'react';
import { IconContext } from "react-icons";
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from 'react-icons/md';

import { THEME_COLOR } from '../../constants';
import { loginRegisterAlert } from './LoginRegisterAlert';

interface Props {
  loggedUser: any;
  data: any;
  dataVoteChange: (likeDislike: number) => void;
}

interface State {
  voteValue: number | null;
  voteChangeProgress: boolean;
};

export class VoteComponent extends React.PureComponent<Props, State> {
  state = { voteValue: 0, voteChangeProgress: false };

  componentWillMount() {
    if (this.props.loggedUser) {
      this.setupVoteValue(this.props.loggedUser.id, this.props.data);
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    const { loggedUser, data } = nextProps;
    if (loggedUser) {
      this.setupVoteValue(loggedUser.id, data);
    }
  }

  setupVoteValue = (loggedUserId: string, data: any) => {
    if (loggedUserId && data && data.votes && data.votes.length !== 0) {
      const selectedVote = data.votes.find((vote: any) => vote.author.id === loggedUserId);
      if (selectedVote) {
        this.setState(() => ({ voteValue: selectedVote.voteValue }));
      }
    }
  }

  onVoteChange = async (newVoteValue: number) => {
    if (!this.props.loggedUser) {
      loginRegisterAlert();
    } else {
      if (this.state.voteChangeProgress) {
        return;
      }
      this.setState(() => ({ voteChangeProgress: true }));
      const oldVoteValue = this.state.voteValue;
      const changeInVoteValue = oldVoteValue + newVoteValue;

      this.setState(() => ({ voteValue: changeInVoteValue }));
      // Calling the mutation for changing the Vote of data
      this.props.dataVoteChange(newVoteValue);
      this.setState(() => ({ voteChangeProgress: false }));
    }
  }

  render() {
    const { data } = this.props;
    const { voteValue } = this.state;
    return (
      <React.Fragment>
        <span onClick={() => this.onVoteChange(1)} style={{ cursor: 'pointer' }}>
          <span style={styles.buttonTextStyle} > {data.likes} </span>
          <IconContext.Provider value={{
            size: "1.5em", style: voteValue === 1 ? styles.voteIconStyleSelected : styles.voteIconStyle
          }}>
            <MdKeyboardArrowUp />
          </IconContext.Provider>
        </span>
        <span onClick={() => this.onVoteChange(-1)} style={{ marginLeft: 10, cursor: 'pointer' }}>
          <span style={styles.buttonTextStyle} > {data.dislikes} </span>
          <IconContext.Provider value={{
            size: "1.5em", style: voteValue === -1 ? styles.voteIconStyleSelected : styles.voteIconStyle
          }}>
            <MdKeyboardArrowDown />
          </IconContext.Provider>
        </span>
      </React.Fragment>
    );
  }
}

const styles = {
  dateStyle: {
    fontSize: 12,
    color: 'grey',
  },
  buttonsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  buttonTextStyle: {
    color: '#737373',
  },
  voteIconStyle: {
    verticalAlign: 'middle',
  },
  voteIconStyleSelected: {
    color: THEME_COLOR,
    verticalAlign: 'middle',
  },
};




// WEBPACK FOOTER //
// ./src/modules/shared/VoteComponent.tsx